import { Phone, MessageSquare, MessageCircle } from "lucide-react";

export default function MessageSender({
  phoneNumber,
  setPhoneNumber,
  messageToSend,
  setMessageToSend,
  onSend,
  wsReady,
}) {
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <div className="rounded-xl bg-white p-6 shadow-lg transition-colors duration-300 dark:bg-gray-900">
      <h2 className="mb-4 flex items-center text-xl font-semibold text-gray-800 dark:text-gray-100">
        <MessageSquare className="mr-2 h-5 w-5 text-white" /> Enviar Mensagem
      </h2>

      <div className="grid grid-cols-1 gap-4">
        {/* Número */}
        <div>
          <label className="mb-2 flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
            <Phone className="mr-2 h-4 w-4 text-green-500" />
            Número do Telefone *
          </label>
          <input
            type="text"
            placeholder="5511999999999"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-800 outline-none transition-all focus:border-transparent focus:ring-2 focus:ring-green-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100"
          />
        </div>

        {/* Mensagem */}
        <div>
          <label className="mb-2 flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
            <MessageCircle className="mr-2 h-4 w-4 text-green-500" />
            Mensagem *
          </label>
          <div className="flex gap-2">
            <textarea
              placeholder="Digite sua mensagem..."
              value={messageToSend}
              onChange={(e) => setMessageToSend(e.target.value)}
              rows={2}
              className="flex-1 resize-none rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-800 outline-none transition-all focus:border-transparent focus:ring-2 focus:ring-green-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100"
              onKeyDown={handleKeyPress}
            />
            <button
              onClick={onSend}
              disabled={
                !phoneNumber.trim() || !messageToSend.trim() || !wsReady
              }
              className="rounded-lg bg-blue-500 px-6 py-2 font-semibold text-white shadow-lg transition-all hover:bg-blue-600 hover:shadow-xl disabled:cursor-not-allowed disabled:bg-gray-400 dark:disabled:bg-gray-600"
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
